<template>
  <div>
    <p class="text-grey mb-3">Redeem Coupon Code</p>
    <div class="w-full">
      <vs-input
        v-model="couponCode"
        class="w-full coupon-code"
        @input="verifyCouponCode"
        @keyup.enter="verifyCouponCode"
      />
      <span v-if="couponCode && !validCouponCode" class="text-danger mt-5"
        >Invalid Coupon Code</span
      >
    </div>

    <vs-divider class="mb-base" />

    <p class="text-grey mb-3">Enter Amount</p>
    <div class="w-full mb-3">
      <vs-input
        v-model="amount"
        class="w-full"
        type="Number"
        :disabled="validCouponCode"
      />
      <span v-if="amount < 0" class="text-danger mt-5">Invalid Amount</span>
    </div>

    <div class="flex justify-content-end mb-base">
      <div
        class="mr-3 cursor-pointer x-plus-amount"
        color="primary"
        @click="xPlusAmount(1000)"
      >
        + €1000
      </div>
      <div
        class="mr-3 cursor-pointer x-plus-amount"
        color="primary"
        @click="xPlusAmount(2000)"
      >
        + €2000
      </div>
      <div
        class="mr-3 cursor-pointer x-plus-amount"
        color="primary"
        @click="xPlusAmount(5000)"
      >
        + €5000
      </div>
    </div>
    <vs-button
      v-if="!validCouponCode"
      class="w-full"
      @click.prevent="addFunds('stripe')"
      :disabled="!validAmount"
      >Add Funds</vs-button
    >
    <vs-button v-else class="w-full" @click.prevent="addFunds('coupon_code')"
      >Add Funds</vs-button
    >
  </div>
</template>

<script>
import AddFunds from '../components/AddFunds.vue';

export default {
  data() {
    return {
        couponCode: null,
        validCouponCode: false,
        validCouponCodes: ['GTBRDD2000', 'GTBRDD5000', 'GTBRDD10000'],
        transactions: [],
        amount: 0,
        currency: 'eur'
    };
  },
  components: {
    AddFunds
  },
  computed: {
    validAmount() {
        return this.amount && this.amount > 0;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    couponAmount() {
      return Number((this.couponCode.toUpperCase().split('GTBRDD'))[1]);
    },

  },
  methods: {
    xPlusAmount(x) {
      if(!this.validCouponCode) this.amount = Number(this.amount) + x;
    },
    verifyCouponCode() {
      this.validCouponCode = false;
      if(this.couponCode && this.validCouponCodes.includes(this.couponCode.toUpperCase())) {
        this.validCouponCode = true;
        this.amount = this.couponAmount;
      }
    },
    proceedToPayment() {
      return;
    },
    addFunds(source) {
      if(!this.orgData || !this.userData) return;

      this.$vs.loading();

      let amount = 0;
      if(source === 'coupon_code') {
        amount = this.couponAmount;
      } else {
        amount = this.amount;
      }

      if(amount === 0) {
        this.$vs.notify({
            title: "Invalid Amount Value",
            color: "danger"
          });
        return;
      }

      const payload = {
        organizationId: this.orgData._id,
        userId: this.userData._id,
        amount,
        currency: this.currency,
        source: source,
        couponCode: this.couponCode,
        stripeProductName: 'Organization Funds' 
      };

      this.$store
        .dispatch("payments/addFunds", payload)
        .then((res) => {
          if(source === 'stripe') {
            window.location.href = res.data.data.stripeRedirectURL;
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: `Successfully added €${amount} to Organization Funds`,
              color: "primary"
            });

            this.$emit('addFundsSuccess');
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Failed to add Organization Funds",
            color: "danger"
          });

          this.$emit('addFundsFailed');

          throw err;
        });
      
      this.couponCode = '';
      this.amount = 0;
    }
  }
};
</script>


<style scoped>
button {
    border-radius: 8px!important;
}

.coupon-code >>> .vs-con-input input.vs-input--input {
  text-transform: uppercase !important;
}

.justify-content-end {
  justify-content: end;
}

.x-plus-amount {
  color: #ffffff;
  background-color: rgba(var(--vs-primary));
  border-radius: 15px;
  padding: 2px 5px;
  font-size: 12px;
}
</style>